import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EmailVerified = () => {
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="container mt-5 pt-5 text-center">
      <h4 className="text-success">✅ Your email has been verified!</h4>
      <p>Redirecting to login in <strong>{countdown}</strong> seconds...</p>
    </div>
  );
};

export default EmailVerified;
